import React, { useCallback, useState } from "react";
import { useForwardVMAction } from "../../hooks/useCallAction";
import ForwardVMUI from "./ForwardVMUI";
import { useRouteConfigModals } from "../contexts/RouteConfigModalsContext";

/**
 * ForwardVM component - can be used for root or off-hours contexts
 * @param {string} context - 'root' | 'offHours' (defaults to 'root')
 */
const ForwardVM = ({ 
  setOpenConfigureSlotModal, 
  route, 
  setRoute,
  context = 'root',
  hasValidationError = false,
}) => {
  const routeModals = useRouteConfigModals();
  const [localRecordings] = useState(
    () => JSON.parse(localStorage.getItem("organization"))?.recordings?.L || []
  );
  const [localChannels] = useState(
    () => JSON.parse(localStorage.getItem("organization"))?.channels?.L || []
  );
  const recordings = routeModals?.recordings ?? localRecordings;
  const channels = routeModals?.channels ?? localChannels;
  const forwardVMLogic = useForwardVMAction(context, route, setRoute);

  const handleDestinationChange = useCallback(
    (value) => {
      const [channelId, phoneFromModal] = Array.isArray(value) ? value : [value, undefined];
      const phone = phoneFromModal ?? (() => {
        const ch = channels?.find((c) => (c.M?.ch_id?.S ?? c.ch_id) === channelId);
        return ch ? (ch.M?.value?.S ?? ch.value) : channelId;
      })();
      forwardVMLogic.handleNumberChange(phone);
    },
    [channels, forwardVMLogic.handleNumberChange]
  );

  const addDestinationOption = routeModals
    ? { label: "Add Forwarding Number", onClick: () => routeModals.openAddChannelModal("forward_number", handleDestinationChange) }
    : undefined;
  const addRecordingOption = routeModals
    ? { label: "Add Recording", onClick: () => routeModals.openAddRecordingModal(forwardVMLogic.handleRecordingChange) }
    : undefined;

  return (
    <ForwardVMUI
      {...forwardVMLogic}
      setOpenConfigureSlotModal={setOpenConfigureSlotModal}
      channels={channels}
      recordings={recordings}
      hasValidationError={hasValidationError}
      addDestinationOption={addDestinationOption}
      addRecordingOption={addRecordingOption}
      onDestinationChange={handleDestinationChange}
    />
  );
};

export default ForwardVM;
